import { TixSecondaryTypes } from '../../types/TixTypes';

export const secondaryWithOptionalReference: TixSecondaryTypes[] = [
	TixSecondaryTypes.TICKETSWAP,
	TixSecondaryTypes.MARKTPLAATS,
];
